import React from 'react';

import jquery from 'jquery';
import {createPortal} from 'react-dom';
import {useDispatch, useSelector} from 'react-redux';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import styled from 'styled-components';

import {hideNotification, toggleIsHovering} from 'app/toasts/slice';

import {ToastNotification} from './ToastNotification';

import {useNotifications} from '../hooks';

const containerID = 'toast-messages-container';

const getToastsContainerNode = (): Element => {
  const selector = `#${containerID}`;
  return jquery(
    jquery(selector).length
      ? selector
      : (jquery('<div />').attr('id', containerID).appendTo('body') as any)
  ).get(0);
};

export function ToastNotificationsContainer() {
  const dispatch = useDispatch();
  const messages = useSelector((state) => [...state.toasts.messages].reverse());
  const {showToastNotification} = useNotifications();
  const containerNodeRef = React.useRef(getToastsContainerNode());

  const toggleHovering = () => dispatch(toggleIsHovering());

  React.useEffect(() => {
    setTimeout(function readDjangoMessages() {
      jquery('#messages > *').each((idx, node) => {
        const $node = jquery(node);
        showToastNotification($node.text(), {
          level: $node.data('level') || 'info',
        });
      });
    }, 1000);
  }, []);

  return createPortal(
    <StyledToastNotificationContainerDiv
      onMouseEnter={toggleHovering}
      onMouseLeave={toggleHovering}
    >
      <TransitionGroup>
        {messages.map(({text, messageId, level, link}) => (
          <CSSTransition key={messageId} timeout={250} classNames="toast">
            <ToastNotification
              link={link}
              messageId={messageId}
              level={level}
              onClose={(id) => dispatch(hideNotification(id))}
            >
              {text}
            </ToastNotification>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </StyledToastNotificationContainerDiv>,
    containerNodeRef.current
  );
}

export const StyledToastNotificationContainerDiv = styled.div.attrs({
  className: 'd-print-none',
})`
  position: fixed;
  top: 50px;
  z-index: 1070;
  left: 50%;
  transform: translate(-50%, 0);

  .toast-enter {
    opacity: 0.01;
    transform: translate(0, -10px);
  }

  .toast-enter-active {
    opacity: 1;
    transform: translate(0, 0);
    transition: all 250ms ease-out;
  }

  .toast-exit {
    opacity: 1;
    transform: translate(0, 0);
  }

  .toast-exit-active {
    opacity: 0.01;
    transform: translate(0, -10px);
    transition: all 250ms ease-out;
  }

  .alert {
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.25);
  }
`;
